<template>
    <div class="container p-3 pt-5 my-4 border in-border-header">
        <form id="card_to_card_change_status_form">
            <kt-form-section is_first>
                <div class="section-header">
                    {{ $t('label.change_status') }}
                </div>
                <kt-form-group>
                    <kt-form-label>
                        {{ $t('label.status') }}
                    </kt-form-label>
                    <kt-form-select
                        size="3"
                        id="status"
                        name="status"
                        v-model="form_data.status"
                    >
                        <option
                            v-bind:key="index"
                            v-for="(status, index) in cardToCardStatus"
                            v-bind:value="status"
                            :selected="form_data.status === status"
                        >
                            {{ cardToCardStatusStr.get(status) }}
                        </option>
                    </kt-form-select>
                </kt-form-group>
                <div style="text-align: end">
                    <button type="button"
                            @click="changeStatus"
                            class="btn btn-success"
                            id="card_to_card_change_status_btn"
                            v-text="$t('btn.edit')"
                    >
                    </button>
                </div>
            </kt-form-section>
        </form>
    </div>
</template>

<script>
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import {cardToCardService} from "@/common/api.service";
import {i18n} from "@/plugins/i18n";
import {mapGetters} from "vuex";
import {cardToCardStatus, cardToCardStatusStr} from "../../../constants/cardToCard";

export default {
    data() {
        return {
            cardToCardStatus,
            cardToCardStatusStr
        };
    },
    mounted() {
    },
    computed: {
        ...mapGetters('cardToCard', [
            'form_data', 'status'
        ]),
    },
    methods: {
        changeStatus() {
            let btn = $('#card_to_card_change_status_btn');
            let form = $('#card_to_card_change_status_form');

            form.validate({
                rules: {
                    status: {
                        required: true,
                    }
                }
            });

            if (!form.valid()) {
                return
            }

            KTApp.progress(btn);

            cardToCardService.adminChangeGatewayStatus(this.form_data.id, {
                status: this.form_data.status
            }).then(response => {
                this.showMsg(form, 'success', response.data.message);
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', i18n.t('message.an_error_accord'))
            }).finally(response => {
                    KTApp.unprogress(btn);
                }
            )
        },
    },
}
</script>

<style>
</style>
